import {
    shuffle as _shuffle,
    range as _range,
} from '@lodash';

export default class MathUtils {
    public static isNumber(value: any) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    public static generateRandomNumberArray({
        count,
        minValue,
        maxValue
    }: {
        count: number,
        minValue: number,
        maxValue: number,
    }): number[] {
        return _shuffle(_range(minValue, maxValue + 1)).slice(0, count);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/math/MathUtils.ts